module.exports = __webpack_public_path__ + "static/media/dentalroom02.59c48833.jpg";